<template>
  <section class="mt-4">
    <h1 class="text-gray-500 text-md mb-2 mt-2">
      A title element displays the title of the narrative, as well as
      information about the author.
    </h1>

    <section class="bg-gray-100 p-4 mt-2 rounded-md">
      <label
        for="number-ticks"
        class="block text-sm leading-5 font-medium text-gray-700 mb-2"
        >Title</label
      >
      <input
        v-model="element.title"
        class="form-input block w-full transition duration-150
              ease-in-out sm:text-sm sm:leading-5"
      />

      <label
        for="author"
        class="mt-2 block text-sm leading-5 font-medium text-gray-700 mb-2"
        >Author</label
      >
      <input
        v-model="element.author"
        class="form-input block w-full transition duration-150
              ease-in-out sm:text-sm sm:leading-5"
      />
    </section>

    <!-- OTHER OPTIONS! -->
    <color-form :element='element'></color-form>
    <animation-form :element="element"></animation-form>
    <pin-form :element='element'></pin-form>
  </section>
</template>

<script>
// import Component from "../component_location"
import AnimationForm from "@/components/ElementForm/AnimationForm.vue";
import ColorForm from '@/components/ElementForm/ColorForm.vue'
import PinForm from '@/components/ElementForm/PinForm.vue'

export default {
  components: { AnimationForm, ColorForm, PinForm },

  props: ["element"],

  data() {
    return {};
  },

  watch: {},

  methods: {},

  computed: {},

  mounted() {},
};
</script>

<style></style>
